/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import type { JSX } from 'react'
import type { Mesh, MeshStandardMaterial } from 'three'
import { type GLTF } from 'three-stdlib'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      background001_1: Mesh
      background001_2: Mesh
      background001_3: Mesh
      background001_4: Mesh
    }
    materials: {
      BlackStruss: MeshStandardMaterial
      MetalStruss: MeshStandardMaterial
      Black: MeshStandardMaterial
      Glow: MeshStandardMaterial
    }
  }

export function Stage(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('/models/stage.glb') as GLTFResult
  return (
    <group {...props} dispose={null}>
      <group scale={100}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.background001_1.geometry}
          material={materials.BlackStruss}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.background001_2.geometry}
          material={materials.MetalStruss}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.background001_3.geometry}
          material={materials.Black}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.background001_4.geometry}
          material={materials.Glow}
        />
      </group>
    </group>
  )
}

useGLTF.preload('/models/stage.glb')
